var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-32"},[_c('h1',[_vm._v("Page Not Found...")]),_c('p',[_vm._v(" Oops we couldn't find that page. Try going "),_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("home")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }